<template>
    <div class="about">
        <horizontal-slider
            class="hidden-sm-and-up"
            v-if="newsList.length !== 0"
            :list="newsList"
            :index="index"
            @handleClick="linkToDetails"
        ></horizontal-slider>
        <!-- 头部 -->
        <div class="head_picture">
            <img src="../assets/images/banner_1.png" class="hidden-xs-only" />
            <img src="../assets/images/banner_11.png" class="hidden-sm-and-up" />
        </div>
        <!-- 主体 -->
        <div class="section main">
            <div class="main_left hidden-xs-only">
                <div class="main_left_title">
                    <img src="../assets/images/title_about.png" />
                </div>
                <div class="main_left_content">
                    <p v-for="(item, i) in newsList" :key="i" :class="[ index == item.id ? 'list_active' : '' ]" @click="linkToDetails(item.id)">{{ item.title }}</p>
                </div>
            </div>
            <div class="main_right" v-loading="loading">
                <div class="crumb_navigation">
                    <span>当前位置：</span>
                    <span>关于联盟</span><i class="el-icon-arrow-right"></i>
                    <span>{{ newsDetails.title }}</span>
                </div>
                <div v-if="newsDetails !== ''">
                    <div class="article_title">
                        <h3>{{ newsDetails.title }}</h3>
                        <p>更新时间：{{ newsDetails.releaseTimeString }}</p>
                    </div>
                    <div class="common_artical" v-html="newsDetails.content"></div>
                </div>
                <div v-else class="common_null">暂无数据</div>
            </div>
        </div>
        <!--  -->
    </div>
</template>

<script>
import HorizontalSlider from '../components/HorizontalSlider.vue'
import { newsType, newsList, newsDetails } from '../untils/common-api.js'
export default {
    data() {
        return {
            loading: false,
            // 
            index: '',
            query: {
                current: 1,
                pageSize: 10,
                newsType: null
            },
            newsList: [],
            newsDetails: ''
        }
    },
    methods: {
        // 获取新闻类型
        async getNewsType() {
            let res = await newsType()
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            res.data.records.forEach(item => {
                if (item.typeName === '关于联盟') {
                    this.query.newsType = item.id
                }
            })
            this.getNewsList()
        },
        // 获取新闻列表
        async getNewsList() {
            let res = await newsList(this.query)
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            this.newsList = res.data.records
            console.log(this.newsList)
            if (this.$route.query.type) {
                this.index = this.$route.query.type
            } else {
                this.index = res.data.records[0].id
            }
            this.getNewsDetails(this.index)
        },
        // 获取新闻详情
        async getNewsDetails(index) {
            this.loading = true // loading start
            let res = await newsDetails(index)
            this.loading = false // loading end
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            console.log(res)
            if (res.length !== 0) {
                this.newsDetails = res.data
            } else {
                this.newsDetails = ''
            }
        },
        linkToDetails(id) {
            this.index = id
            this.getNewsDetails(id)
            window.location.href = '/#/about?type=' + id
        }
    },
    components: {
        HorizontalSlider
    },
    created() {
        this.getNewsType()
    }
}
</script>

<style lang="less">
.about {
    .main {
        color: #666;
        overflow: auto;
        .main_left {
            width: 20%;
            float: left;
            background: #fff;
            .main_left_title {
                margin-bottom: 10px;
                img {
                    width: 100%;
                }
            }
            .main_left_content {
                p {
                    font-size: 15px;
                    line-height: 45px;
                    text-align: center;
                    border-bottom: 1px solid #dcdcdc;
                    transition: 0.3s ease all;
                    cursor: pointer;
                    &:hover {
                        color: #037EDB;
                        background: #dcdcdc;
                    }
                }
            }
        }
        .main_right {
            width: calc(80% - 40px);
            float: right;
            background: #fff;
            .article_title {
                text-align: center;
                border-bottom: 1px dashed #dcdcdc;
                padding-bottom: 20px;
                margin-bottom: 25px;
                h3 {
                    font-size: 22px;
                    margin-bottom: 10px;
                }
            }
        }
    }
    .list_active {
        color: #037EDB;
        background: #dcdcdc;
    }
}
@media (max-width: 768px) {
    .about {
        .main {
            .main_right {
                width: 100%;
                .article_title {
                    border-bottom: none;
                    padding-bottom: 0;
                    margin-bottom: 0.3rem;
                    h3 {
                        font-size: 0.4rem;
                        margin-bottom: 0.15rem;
                    }
                }
            }
        }
    }
}
</style>